// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"8763a534","455":"54f4cb91","585":"9b80c6ef"}[chunkId] + ".chunk.js";
};